import AOS from "aos";
import * as bootstrap from "bootstrap";
import gsap from "gsap";
// import {ScrollTrigger} from "gsap/ScrollTrigger";

// gsap.registerPlugin(ScrollTrigger);

window.onresize = () => {
    document.body.height = window.innerHeight;
}

let lastPos = window.scrollY;
let lastTime = Date.now();
let up = false;

window.addEventListener('scroll', () => {
    let currentPos = window.scrollY;
    let currentTime = Date.now();

    let distance = Math.abs(currentPos - lastPos);
    let timeElapsed = currentTime - lastTime;

    let speed = distance / timeElapsed * 1000; // pixels per millisecond
    let up = lastPos > currentPos;
    lastPos = currentPos;
    lastTime = currentTime;
});


function nextSection(){
    for (const section of document.querySelectorAll('.section')) {
        let y = section.getBoundingClientRect().y;
        if(y > 0){
            return section;
        }
    }
}

document.getElementById('NextBtn').addEventListener('click', (event) => {
    event.preventDefault();
    event.stopPropagation();
    window.scrollTo(0, nextSection().getBoundingClientRect().y + window.scrollY);
})

document.querySelectorAll('.rotator').forEach((rotator) => {
    let tl = gsap.timeline({repeat: -1});
    let duration = 1;
    let delay = 3;
    rotator.querySelectorAll('.rotator-line').forEach((line, index, lines) => {
        let next = index === lines.length - 1 ? lines[0] : lines[index + 1];
        tl.to(line, {duration: 1, opacity: 0}, ">3");
        tl.to(next, {duration: 1, opacity: 1}, ">-1");
    })
})

document.querySelectorAll('.images-references > .rotator').forEach((rotator) => {
    let tl = gsap.timeline({repeat: -1});
    let duration = 0.2;
    let delay = 1;
    rotator.querySelectorAll('.mediaelement').forEach((el, index, els) => {
        let next = index === els.length - 1 ? els[0] : els[index + 1];
        tl.to(next, {duration: duration, opacity: 1}, ">" + delay);
        tl.set(el, {opacity: 0}, ">0");
    })
})

document.addEventListener('DOMContentLoaded', () => AOS.init());
